/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { cloneDeep, remove } from 'lodash';
import PropTypes, { any } from 'prop-types';

import { email } from '../../../../utils/form-validation';
import InfoButton from '../../../InfoButton';
import {
    Input,
    PhoneNumber,
} from '../../../Form';
import BackgroundImage from '../../../BackgroundImage';
import links from '../../../../../config/links';

import Popup from '../../../../pages/EventProfiles/popup/popup';
import AddOrganizerPopup from '../addOrganizerPopUpNew';

const _ = { cloneDeep, remove };

const EventOrganizers = (props) => {
    const {
        formApi,
        organizers,
        clubOrganizers,
        setOrganizers,
        PopUpTypes,
    } = props;

    const [showEventOrganizers, setShowEventOrganizers] = useState(false);
    const [showAddOrganizerPopUp, setShowAddOrganizerPopUp] = useState(false);
    const [removingOrganizerId, setRemovingOrganizerId] = useState(null);
    const [showRemovingOrganizerPopup, setShowRemovingOrganizerPopup] = useState(false);
    const [topPoint, setTopPoint] = useState(null);

    const { setValue } = formApi;

    const getOrganizerObject = (clubMember) => {
        const organizer = {
            memberId: clubMember.memberId,
            firstName: clubMember.firstName,
            lastName: clubMember.lastName,
            imgUrl: '/img/v2/icons/icon-avatar-player.svg',
            // eslint-disable-next-line eqeqeq
            title: clubMember.eventDirectorRole == 2 ? 'Head Provider' : 'Event Provider',
            eventDirectorRole: clubMember.eventDirectorRole,
        };
        return organizer;
    };

    const addOrganizer = () => {
        setShowAddOrganizerPopUp(true);
    };

    const updateOrganizers = (clubMembers) => {
        const updatedOrganizers = [];
        clubMembers.forEach((clubMember) => {
            if (clubMember.isSelected) {
                updatedOrganizers.push(getOrganizerObject(clubMember));
            }
        });
        if (setOrganizers) {
            setOrganizers(updatedOrganizers);
        }
        setShowAddOrganizerPopUp(false);
    };

    const removeOrganizer = (ev, organizerId) => {
        ev.persist();
        setRemovingOrganizerId(organizerId);
        setShowRemovingOrganizerPopup(true);
        setTopPoint(ev ? ev.nativeEvent.pageY : null);
    };

    const handlePopUpConfirm = () => {
        const updatedOrganizers = _.cloneDeep(organizers);
        if (removingOrganizerId) {
            _.remove(updatedOrganizers, { memberId: removingOrganizerId });
        }

        setOrganizers(updatedOrganizers);
        setRemovingOrganizerId(null);
        setShowRemovingOrganizerPopup(false);
        setTopPoint(null);
    };

    return (
        <div className="col-12">
            <div
                className={`form-block-divider ${showEventOrganizers ? 'is-open' : ''} clickable mb16`}
                data-testid="event-edit.event-organizers.toggle"
                onClick={() => {
                    setShowEventOrganizers(!showEventOrganizers);
                }}
            >
                <div className="title">
                    <div><label>Event Providers</label></div>
                    <small style={{ textTransform: 'unset' }}>Add/remove providers and edit contact info</small>
                </div>
                <div className="click-area click-area-32">
                    <i className={`uts uts-${showEventOrganizers ? 'collapse' : 'expand'}-arrow`} />
                </div>
            </div>
            {showEventOrganizers && (
                <div className={`row`}>
                    <div className="col-12">
                        <div className="form-group form-group-xl">
                            <label>
                                Event Providers
                                <InfoButton hoverText={(
                                    <ul>
                                        <li>
                                            All providers automatically have admin access to this event (even if they are not listed below).
                                        </li>
                                        <li>
                                            Only <a href={links.support} target="_blank" rel="noopener noreferrer">Premium Clubs</a> , HS, and College Clubs can add additional providers.
                                        </li>
                                    </ul>
                                )}
                                />
                            </label>
                            <small>
                                Providers have access to edit the event, communicate with and manage player registrations, create draws and post scores.
                            </small>
                            {organizers && organizers.map((organizer, idx) => {
                                return (
                                    <div className="event-admin-card d-flex" key={idx}>
                                        <BackgroundImage
                                            baseUrl={'/v1/player/'}
                                            defaultImage={'/img/v2/icons/icon-avatar-player.svg'}
                                            images={organizer.playerProfileImages}
                                            imageType={'icon'}
                                            parentStylesClass={'avatar'}
                                        />
                                        <div className="person-details">
                                            <div className="person-title text-small text-medium">
                                                {organizer.title}
                                            </div>
                                            <div className="person-name text-dark">
                                                <span>{organizer.firstName} {organizer.lastName}</span>
                                                {organizers.length > 1 && (
                                                    <small
                                                        className="cursor-pointer text-teal ml8 d-inline-block"
                                                        data-testid={`event-edit.remove-organizer-btn-${organizer.memberId}`}
                                                        onClick={(ev) => {
                                                            removeOrganizer(ev, organizer.memberId);
                                                        }}
                                                    >
                                                        Remove
                                                    </small>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                            <small
                                className="cursor-pointer text-teal"
                                data-testid="event-edit.add-organizer-btn"
                                onClick={addOrganizer}
                            >
                                Add Event Provider
                            </small>
                        </div>
                        <Input
                            label="Provider contact email"
                            description="Please provide a contact email address to be visible on your event page."
                            id="email"
                            field="email"
                            type="email"
                            placeholder="name@example.com"
                            validate={email}
                            disableProfanityCheck={true}
                        />
                        <PhoneNumber
                            label="Provider contact phone"
                            description="Please provide a contact phone number for event questions."
                            hoverText="This phone number will be visible to all players on the event page and will be one of their options to reach out for questions."
                            id="phone"
                            field="phone"
                            placeholder="(212) 555-5555"
                            onChange={(val) => {
                                if (!val) {
                                    setValue('phone', null);
                                }
                            }}
                        />
                    </div>
                </div>
            )}
            {showAddOrganizerPopUp && (
                <AddOrganizerPopup
                    closePopup={() => {
                        setShowAddOrganizerPopUp(false);
                    }}
                    organizers={organizers}
                    clubMembers={clubOrganizers}
                    confirmPopup={updateOrganizers}
                />
            )}
            {showRemovingOrganizerPopup && (
                <Popup
                    closePopup={() => {
                        setShowRemovingOrganizerPopup(false);
                    }}
                    confirmPopup={handlePopUpConfirm}
                    message={PopUpTypes.REMOVE_EVENT_DIRECTOR.message}
                    topPoint={topPoint}
                />
            )}
        </div>
    );
};

EventOrganizers.propTypes = {
    formApi: PropTypes.objectOf(any).isRequired,
    organizers: PropTypes.objectOf(Array),
    clubOrganizers: PropTypes.objectOf(Array),
    setOrganizers: PropTypes.func,
    PopUpTypes: PropTypes.objectOf(any).isRequired,
};

EventOrganizers.defaultProps = {
    organizers: PropTypes.array,
    clubOrganizers: PropTypes.array,
    setOrganizers: () => {},
};

export default EventOrganizers;
